module.exports = __webpack_public_path__ + "static/img/14.c3031f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/14.png
// module id = CQna
// module chunks = 0